(function($) {
	$.fn.loadTemplate = function() {
		var source = this.html();
		source = source.replace(/src="((\.\.\/)+){{/, "src=\"{{");
		return Handlebars.compile(source);
	}
})(window.jQuery);